import React from "react";
import IconAction from "../../../shared/components/generic/button/icon-action/icon-action";
import CnpjUtils from "../../../shared/utils/CnpjUtils";

export const getDashboardParticipantClientsColumns = ({
    onSelectClient,
    actionTitle = "Selecionar cliente",
    actionVariant = "view"
}) => [
        {
            key: "name",
            label: "Cliente",
            width: "34%"
        },
        {
            key: "document",
            label: "CNPJ",
            width: "22%",
            render: row => CnpjUtils.formatAlphanumericCnpj(row.document)
        },
        {
            key: "groupName",
            label: "Grupo",
            width: "28%",
            render: row => row.groupName || "-"
        },
        {
            key: "actions",
            label: "Ações",
            width: "80px",
            render: row => (
                <IconAction
                    row={row}
                    actions={[
                        {
                            key: actionVariant,
                            variant: actionVariant,
                            title: actionTitle,
                            ariaLabel: actionTitle,
                            onClick: onSelectClient
                        }
                    ]}
                />
            )
        }
    ];